import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { HiMenu, HiX } from 'react-icons/hi';
import logo from '../../assets/images/grunge-bb-logo.png';
import siteContent from '../../data/siteContent.json';

const navigation = [
  { name: 'Meet the Team', href: '/about' },
  { name: 'Services', href: '/services' },
  { name: 'Portfolio', href: '/portfolio' },
  { name: 'Reviews', href: '/reviews' },
  { name: 'Preparation Guide', href: '/preparation-guide' },
  { name: 'Contract Policies', href: '/contract-policies' },
  { name: 'Med Spa', href: '/med-spa' },
  { name: 'Contact', href: '/contact' },
  { name: 'Coming Soon', href: '/coming-soon' },
];

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="bg-black sticky top-0 z-50 border-b border-charcoal pt-3 pb-2">
      <nav className="container-custom">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-start self-start pt-0">
            <img
              src={logo}
              alt="Blush & Bobby"
              className="h-28 lg:h-40 w-auto border-[8px] border-black rounded-2xl shadow-xl"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex lg:items-center lg:gap-4 xl:gap-8">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.href}
                className={({ isActive }) =>
                  `text-sm font-medium transition-all duration-300 hover:text-dusty-rose px-3 py-1.5 rounded-lg border text-center ${
                    isActive 
                      ? 'text-dusty-rose border-dusty-rose/40 bg-dusty-rose/5' 
                      : 'text-chalk border-transparent'
                  }`
                }
              >
                {item.name}
              </NavLink>
            ))}
            <a
              href={siteContent.social.linktree}
              target="_blank"
              rel="noopener noreferrer"
              className="ml-2 inline-flex items-center justify-center text-center px-5 py-2 border-2 border-[#fe67b8] bg-[#fe67b8] text-white text-sm font-medium rounded hover:bg-[#fe67b8]/90 transition-colors focus:outline-none focus:ring-2 focus:ring-[#fe67b8] focus:ring-offset-2 focus:ring-offset-charcoal"
            >
              Book Now
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex lg:hidden">
            <button
              type="button"
              className="text-chalk hover:text-dusty-rose p-2 -mr-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-expanded={mobileMenuOpen}
              aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'}
            >
              {mobileMenuOpen ? (
                <HiX className="h-6 w-6" />
              ) : (
                <HiMenu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden pb-4 border-t border-charcoal-dark pt-4">
            <div className="flex flex-col gap-1">
              <NavLink
                to="/"
                onClick={() => setMobileMenuOpen(false)}
                className={({ isActive }) =>
                  `text-base font-medium py-2 px-3 rounded-lg text-center ${
                    isActive
                      ? 'text-dusty-rose bg-dusty-rose/10'
                      : 'text-chalk hover:bg-charcoal-dark'
                  }`
                }
              >
                Home
              </NavLink>
              {navigation.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className={({ isActive }) =>
                    `text-base font-medium py-2 px-3 rounded-lg text-center ${
                      isActive
                        ? 'text-dusty-rose bg-dusty-rose/10'
                        : 'text-chalk hover:bg-charcoal-dark'
                    }`
                  }
                >
                  {item.name}
                </NavLink>
              ))}
              <a
                href={siteContent.social.linktree}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setMobileMenuOpen(false)}
                className="mt-2 inline-flex items-center justify-center text-center px-6 py-3 border-2 border-[#fe67b8] bg-[#fe67b8] text-white text-base font-medium rounded hover:bg-[#fe67b8]/90 transition-colors"
              >
                Book Now
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
